import {AlertTypeIdsEnum, TagIdsEnum} from "../componentObjects";

export function consolidateAlerts(alerts, isDeviceHealthAlerts) {
    const distinctAlerts = [];
    const consolidatedAlertsDict = {};

    for (let i = 0; i < alerts.length; i++) {
        const currentAlert = alerts[i];
        const typeId = currentAlert.typeId;
        const assetId = currentAlert.alert.assetId;
        
        if (!distinctAlerts.some(a => a.typeId === typeId && a.alert.assetId === assetId)) {
            const currentAssetAlertsByType = alerts.filter(a => a.typeId === typeId && a.alert.assetId === assetId);
            const conversationIds = currentAssetAlertsByType.map(o => o.alert.conversationId).filter(id => id != null);
            const highestConversationId = conversationIds.length ? Math.max(...conversationIds) : 0;
            const alertWithHighestConversationId = currentAssetAlertsByType.find(a => a.alert.conversationId === highestConversationId);
            
            currentAssetAlertsByType.sort((a, b) => {
                const startA = new Date(a.alert.startTime);
                const startB = new Date(b.alert.startTime);
                return startB - startA;
            });

            const distinctAlert = currentAssetAlertsByType[0]; // newest
            const distinctUnitId = distinctAlert.alert.pathNames && distinctAlert.alert.pathNames.length > 2 ? distinctAlert.alert.pathNames[2].split('-')[0] : null;
            
            if (isDeviceHealthAlerts && distinctAlert.typeId === AlertTypeIdsEnum.UnitOffline && distinctUnitId !== null &&
                distinctAlerts.some(d => d.typeId === distinctAlert.typeId && d.alert.assetId === assetId &&
                        d.alert.pathNames?.length > 2 && d.alert.pathNames[2].split('-')[0] === distinctUnitId)) {
                
                const prevDistinctAlert = distinctAlerts.find(d => d.typeId === distinctAlert.typeId && d.alert.assetId === assetId &&
                        d.alert.pathNames?.length > 2 && d.alert.pathNames[2].split('-')[0] === distinctUnitId);
                
                if (!consolidatedAlertsDict[prevDistinctAlert.typeId]) {
                    consolidatedAlertsDict[prevDistinctAlert.typeId] = {};
                }
                
                const prevUnitAlerts = consolidatedAlertsDict[prevDistinctAlert.typeId][prevDistinctAlert.alert.assetId] || [];
                const existingIds = new Set(prevUnitAlerts.map(a => a.alertId));
                const newAlerts = currentAssetAlertsByType.filter(a => !existingIds.has(a.alertId));
                
                consolidatedAlertsDict[prevDistinctAlert.typeId][prevDistinctAlert.alert.assetId] = prevUnitAlerts.concat(newAlerts);
            } else {
                if (highestConversationId !== 0 && alertWithHighestConversationId) {
                    distinctAlert.alert.conversationId = highestConversationId;
                    distinctAlert.commentsCount = alertWithHighestConversationId.alert.conversationItemCount;
                    distinctAlert.alert.conversationItemCount = alertWithHighestConversationId.alert.conversationItemCount;
                }

                distinctAlerts.push(distinctAlert);
                
                if (!consolidatedAlertsDict[typeId]) {
                    consolidatedAlertsDict[typeId] = {};
                }
                
                consolidatedAlertsDict[typeId][assetId] = currentAssetAlertsByType;
            }
        }
    }

    distinctAlerts.sort((a, b) => {
        let aAlerts = consolidatedAlertsDict[a.typeId][a.alert.assetId];
        let bAlerts = consolidatedAlertsDict[b.typeId][b.alert.assetId];

        if (!aAlerts.some(c => c.alert.tagIds.includes(TagIdsEnum.NewAlert))) {
            if (!bAlerts.some(d => d.alert.tagIds.includes(TagIdsEnum.NewAlert))) {
                return 0;
            } else {
                return 1;
            }
        } else {
            if (!bAlerts.some(d => d.alert.tagIds.includes(TagIdsEnum.NewAlert))) {
                return -1;
            } else {
                return 0;
            }
        }
    });

    return { distinctAlerts, consolidatedAlertsDict };
}